// src/api/authApi.ts
import apiClient from '../api/apiClient';
import {JobPostingRequest} from "../interface/JobPostingRequest";
import {JobPostingData} from "../interface/JobPostingData";
import {JobQuestion} from "../interface/JobQuestion";
import {ResponseDto} from "./ResponseDto";
import {CoordinatorData} from "../interface/CoordinatorData";
import {JobPostingSettings} from "../interface/JobPostingSettings";

export const addJobPosting = (data: JobPostingRequest) =>
    apiClient.post('/api/front/job/addPosting', data);

export const getQuestionList = () =>
    apiClient.get<JobQuestion[]>('/api/front/job/getQuestionList');

export const getJobPostingMatchingList = (params?: { workType?: string | null }) =>
    apiClient.get<JobPostingData[]>('/api/front/job/getJobPostingMatchingList', {
        params : params
    });

export const getJobPostingOngoingList = (params?: { workType?: string | null }) =>
    apiClient.get<JobPostingData[]>('/api/front/job/getJobPostingOngoingList', { params });

export const getJobPostingCompletedList = (params?: { workType?: string | null }) =>
    apiClient.get<JobPostingData[]>('/api/front/job/getJobPostingCompletedList', { params });

// 공고 상세 조회
export const getJobPostingDetail = (jobPostingCode: string) =>
    apiClient.get<ResponseDto<JobPostingData>>(`/api/front/job/detail/${jobPostingCode}`);

export const findTask = (params: {
    workType?: string;
    keyword?: string;
    carePlaceType?: string;
    category?: string;
    offer?: string;
    startDate?: string;
    location?: string;
    gender?: string;
    order?: string;
}) => apiClient.get<JobPostingData[]>(`/api/front/job/findTask`, { params });

export const applyJobPosting = (data: {
    jobPostingCode: string;
    amount: number;
}) => apiClient.post<ResponseDto<any>>(`/api/front/job/apply`, data);


export const getAppliedCoordinators = (jobPostingCode: string) =>
    apiClient.get<CoordinatorData[]>(`/api/front/job/${jobPostingCode}/coordinators`);

export const getCoordinatorDetail = (coordinatorCode: string, jobPostingCode:string) =>
    apiClient.get<CoordinatorData>(`/api/front/coordi/${coordinatorCode}/${jobPostingCode}`);


export const getJobPostingListForMyTask = (params?: { workType?: string | null }) =>
    apiClient.get<JobPostingData[]>('/api/front/job/getJobPostingListForMyTask', {
        params : params
    });
/**
 * 공고 취소
 */
export const cancelJobPosting = (jobPostingCode: string) =>
    apiClient.delete<ResponseDto<void>>(`/api/front/job/${jobPostingCode}`);


export const getJobPostingSettings = () =>
    apiClient.get<JobPostingSettings>('/api/front/job/get-job-posting-settings');


// 종료 신청 - 매칭 코디가 종료일 이후 종료 신청 (급여 협의 포함)
export const requestEndJobPosting = (data: {
    jobPostingCode: string;
    payOption: string;       // 'keep' | 'adjust'
    adjustDirection: string; // 'deduct' | 'add'
    adjustAmount: number;
}) => apiClient.post<ResponseDto<void>>(`/api/front/job/${data.jobPostingCode}/request-end`, {
    payOption: data.payOption,
    adjustDirection: data.adjustDirection,
    adjustAmount: data.adjustAmount
});

// 종료 확정 - 작성자가 코디의 종료 신청 후 최종 확정 + 후기 저장
export const confirmEndJobPosting = (data: {
    jobPostingCode: string;
    rating: number;
    content: string;
}) => apiClient.post<ResponseDto<void>>(`/api/front/job/${data.jobPostingCode}/confirm-end`, {
    rating: data.rating,
    content: data.content
});

// 코디 후기 목록 조회
export const getCoordinatorReviews = (coordinatorCode: string) =>
    apiClient.get<ResponseDto<any[]>>(`/api/front/job/reviews/${coordinatorCode}`);


// 급여 조정 승인/거절
export const adjustDecisionJobPosting = (jobPostingCode: string, isApproved: boolean) =>
    apiClient.post<ResponseDto<void>>(`/api/front/job/${jobPostingCode}/adjust-decision`, { isApproved });